// console.log('app.js loaded');
// let wpAdmin = document.querySelector('body.wp-admin');
let provinces = document.querySelector("#provinces");
let singlePost = document.querySelector("#single_post");
let postSectionsBox = document.querySelector("#post_section_box");
let postSections = document.querySelector("#post_sections");
let contactSections = document.querySelector("body.kontakt");
let hotspots = document.querySelector("#hotspots");
let tablesInPostContent = document.querySelectorAll(".wp-block-table");

// mobile variant packs toggler
let PACK_1 = document.querySelector("#PACK_1");
let PACK_2 = document.querySelector("#PACK_2");
let PACK_3 = document.querySelector("#PACK_3");

// topbar cookie
const topbarCookie = "topbar";
const topbarExpirationDate = new Date();
topbarExpirationDate.setDate(topbarExpirationDate.getDate() + 1);

const topbarDesktop = document.querySelector(".topBarDesktop#topBar");
const topbarCloseDesktop = document.querySelector(
  ".topBarCloseDesktop#topbarClose"
);

const topbar = document.querySelector("#topBar");
const topbarClose = document.querySelector("#topbarClose");

if (tablesInPostContent.length > 0) {
  const elements = tablesInPostContent;
  function checkAndAddClassForHorizontalScrollbar() {
    elements.forEach((element) => {
      if (element.scrollWidth > element.clientWidth) {
        element.classList.add("has-horizontal-scrollbar");
      } else {
        element.classList.remove("has-horizontal-scrollbar");
      }
    });
  }
  checkAndAddClassForHorizontalScrollbar();
  window.addEventListener("resize", checkAndAddClassForHorizontalScrollbar);
}

function closeTopbar(event) {
  topbar.style.display = "none";
  topbarDesktop.style.display = "none";
  if (!document.cookie.includes(topbarCookie)) {
    document.cookie = `${topbarCookie}=hide; expires=${topbarExpirationDate.toUTCString()}`;
  }
}
if (topbarClose) {
  topbarClose.addEventListener("click", closeTopbar);
}
if (topbarCloseDesktop) {
  topbarCloseDesktop.addEventListener("click", closeTopbar);
}

// langswitch div to mobile menu ul
jQuery(".mobile_menu .menu").append(jQuery(".lang_switch_mobile"));
jQuery(".topbar .menu").append(jQuery(".lang_switch_desktop"));

// mobile menu submenu indicator
const dropIcons = document.querySelectorAll(".drop__icon");
dropIcons.forEach(function (dropIcon) {
  dropIcon.addEventListener("click", function () {
    let subMenu = dropIcon.nextElementSibling;
    if (!subMenu.hasAttribute("hidden")) {
      dropIcon.classList.add("open");
    } else {
      dropIcon.classList.remove("open");
    }
  });
});

if (singlePost) {
  // inpost gutenberg buttons with # in front of href
  const elements = document.querySelectorAll('.wp-block-button [href^="#"]');
  elements.forEach((element) => {
    // element.setAttribute('uk-scroll', 'offset: 200');
  });
}
if (provinces) {
  let mapProvinces = document.querySelectorAll("#provinces polygon");
  let citylists = document.querySelectorAll(".citylist");

  mapProvinces.forEach((province) => {
    province.addEventListener("click", function () {
      let id = province.getAttribute("id");

      citylists.forEach((city) => {
        city.classList.add("uk-hidden");
      });
      document.querySelector("#citylist-" + id).classList.remove("uk-hidden");
    });
  });
}

// generate links to post sections
if (singlePost && postSections) {
  const postContent = document.querySelector(".post__content");
  const headings = postContent.querySelectorAll("h1, h2, h3, h4, h5, h6");

  headings.forEach((heading) => {
    if (heading.textContent) {
      if (!heading.id) {
        let generatedID = heading.textContent.replace(/\s+/g, "-");
        generatedID = generatedID.replace(/[^a-zA-Z0-9-]/g, "");
        generatedID = "a-" + generatedID;
        heading.setAttribute("id", generatedID);
      }

      const linkElement = document.createElement("a");
      linkElement.textContent = heading.textContent;
      linkElement.setAttribute("href", "#" + heading.id);
      linkElement.setAttribute("uk-scroll", "offset:180");
      postSections.appendChild(linkElement);
    } else {
      postSectionsBox.classList.add("uk-hidden");
    }
  });
}

// kontakt
if (contactSections) {
  let scrollAnchor = document.querySelector("#form_content");

  // remove duplicate ID elements
  var ids = {}; // Object to store unique IDs
  var elements = document.querySelectorAll("[id]"); // Select all elements with an ID
  for (var i = 0; i < elements.length; i++) {
    var id = elements[i].id; // Get the ID of the element
    if (id in ids) {
      elements[i].remove(); // Remove the duplicate element
    } else {
      // ids[id] = true; // Store the ID in the object
    }
  }

  document.querySelectorAll(".card__item").forEach((item) => {
    item.addEventListener("click", (event) => {
      let itemTarget = item.getAttribute("data-target");
      let target = document.getElementById(itemTarget);
      let contents = document.querySelectorAll(".kontakt_karta_tresc");
      let contactFormScript;
      let loadFormOnClick = document.querySelectorAll(".load_form_on_click");

      // kontakt_karta_uzyskaj_oferte
      if (target.classList.contains("kontakt_karta_uzyskaj_oferte")) {
        for (let i = 0; i < contents.length; i++) {
          if (contactFormScript) {
            contactFormScript.parentNode.removeChild(contactFormScript);
          }
          contents[i].setAttribute("hidden", true);
          contents[i].classList.add("uk-hidden");
        }

        setTimeout(function () {
          target.removeAttribute("hidden");
          target.classList.remove("uk-hidden");

          setTimeout(function () {
            scrollAnchor.scrollIntoView({ behavior: "smooth" });
            let formWrapper = target.querySelector(
              ".form__wrapper__placeholder"
            );
            let formToMove = document.querySelector("#contactFormWrapper");
            formWrapper.appendChild(formToMove);
          }, 350);
        }, 350);
        // kontakt karta faq+form+info
      } else if (target.classList.contains("kontakt_karta_faq_form_info")) {
        for (let i = 0; i < contents.length; i++) {
          // if ( contents[i].classList.contains('kontakt_karta_uzyskaj_oferte')) {
          //     contents[i].querySelector('.load_form_on_click').innerHTML = '';
          // }
          loadFormOnClick.forEach((element) => {
            element.innerHTML = "";
          });
          if (contactFormScript) {
            contactFormScript.parentNode.removeChild(contactFormScript);
          }
          contents[i].setAttribute("hidden", true);
          contents[i].classList.add("uk-hidden");
        }

        setTimeout(function () {
          target.removeAttribute("hidden");
          target.classList.remove("uk-hidden");

          setTimeout(function () {
            scrollAnchor.scrollIntoView({ behavior: "smooth" });
          }, 350);
        }, 350);

        let tickedid;
        //ticket number random component
        function makeid(length) {
          var result = "";
          var characters =
            "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
          var charactersLength = characters.length;
          for (var i = 0; i < length; i++) {
            result += characters.charAt(
              Math.floor(Math.random() * charactersLength)
            );
          }
          return result;
        }
        //ticket number date component
        const now = new Date();
        const yyyy = now.getFullYear();
        let mm = now.getMonth() + 1;
        let dd = now.getDate();
        if (dd < 10) dd = "0" + dd;
        if (mm < 10) mm = "0" + mm;
        const formattedToday = dd + "" + mm + "" + yyyy;

        //ticket number
        let random = makeid(10);
        tickedid = random + formattedToday;

        target.querySelector('[name="ticketID"]').value = tickedid;

        if (document.readyState === "complete") {
          jQuery(".select2").select2({
            templateResult: formatOption,
            minimumResultsForSearch: -1,
          });
          function formatOption(option) {
            var $option = jQuery(
              "<div><strong>" +
                option.text +
                "</strong></div><div>" +
                option.title +
                "</div>"
            );
            return $option;
          }
          jQuery(".select2").on("select2:select", function (e) {
            let data = e.params.data.id;
            jQuery('[name="menu-738"]').val(data).change();
          });
        }
      } // usług ododatkowe serwis + form
      else if (target.classList.contains("serwis_fotowoltaiki")) {
        for (let i = 0; i < contents.length; i++) {
          if (contactFormScript) {
            contactFormScript.parentNode.removeChild(contactFormScript);
          }
          contents[i].setAttribute("hidden", true);
          contents[i].classList.add("uk-hidden");
        }

        setTimeout(function () {
          let targetNextID = target.id + "-2";
          let targetNext = document.getElementById(targetNextID);
          target.removeAttribute("hidden");
          targetNext.removeAttribute("hidden");
          targetNext.classList.remove("uk-hidden");
          target.classList.remove("uk-hidden");

          setTimeout(function () {
            scrollAnchor.scrollIntoView({ behavior: "smooth" });
          }, 350);
        }, 350);
        // pozostałe
      } else {
        for (let i = 0; i < contents.length; i++) {
          // if ( contents[i].classList.contains('kontakt_karta_uzyskaj_oferte')) {
          //     contents[i].querySelector('.load_form_on_click').innerHTML = '';
          // }
          loadFormOnClick.forEach((element) => {
            element.innerHTML = "";
          });
          if (contactFormScript) {
            contactFormScript.parentNode.removeChild(contactFormScript);
          }
          contents[i].setAttribute("hidden", true);
          contents[i].classList.add("uk-hidden");
        }

        setTimeout(function () {
          target.removeAttribute("hidden");
          target.classList.remove("uk-hidden");

          setTimeout(function () {
            scrollAnchor.scrollIntoView({ behavior: "smooth" });
          }, 350);
        }, 350);
      }
    });
  });
}

if (hotspots) {
  let hotspots_tiggers = hotspots.querySelectorAll(".hotspots .icon");
  let hotspots_bodies = hotspots.querySelectorAll(".hotspots .hotspot__body");

  let mobile_hotspots_tiggers = hotspots.querySelectorAll(
    ".mobile__hotspots .mobile__icon"
  );
  let mobile_hotspots_bodies = document.querySelectorAll(
    ".mobile__hotspots__bodies .hotspot__content"
  );

  hotspots_tiggers.forEach((trigger) => {
    trigger.addEventListener("click", (event) => {
      hotspots_bodies.forEach((body) => {
        if (
          body.getAttribute("id") == trigger.getAttribute("data-hotspot-id")
        ) {
          body.classList.remove("uk-hidden");
        } else {
          body.classList.add("uk-hidden");
        }
      });
    });
  });
  mobile_hotspots_tiggers.forEach((mobile_trigger) => {
    mobile_trigger.addEventListener("click", (event) => {
      mobile_hotspots_bodies.forEach((mobile_body) => {
        if (
          mobile_body.getAttribute("id") ==
          mobile_trigger.getAttribute("data-hotspot-id")
        ) {
          mobile_body
            .querySelector(".uk-accordion-content")
            .removeAttribute("hidden");
          mobile_body.scrollIntoView({
            behavior: "smooth",
            block: "start",
            // inline: 'nearest',
            offsetTop: -150,
          });
        } else {
          mobile_body
            .querySelector(".uk-accordion-content")
            .setAttribute("hidden", "true");
        }
      });
    });
  });
}

const buttonScroll = document.querySelector(".btn-scroll");
if (buttonScroll) {
  if (document.getElementById("zapytaj-o-oferte")) {
    buttonScroll.querySelector("a").setAttribute("uk-scroll", "offset:0");
  } else {
    buttonScroll
      .querySelector("a")
      .setAttribute("href", "https://columbusenergy.pl/lp/zapytaj-o-oferte/");
  }
}
const buttonScrollMobile = document.querySelector(".btn-scroll-mobile");
if (buttonScrollMobile) {
  if (document.getElementById("zapytaj-o-oferte")) {
    buttonScrollMobile
      .querySelector("a")
      .setAttribute("uk-scroll", "offset:-100");
    buttonScrollMobile.addEventListener("click", (event) => {
      document.querySelector(".open_menu").click();
    });
  } else {
    buttonScrollMobile
      .querySelector("a")
      .setAttribute("href", "https://columbusenergy.pl/lp/zapytaj-o-oferte/");
  }
}

jQuery(document).ready(function ($) {
  if ($(window).width() <= 960) {
    $("ul li.menu-item-has-children > a").on("click", function (e) {
      e.preventDefault();
      var parentLi = $(this).parent();
      if (parentLi.hasClass("open")) {
        parentLi.removeClass("open");
      } else {
        $("ul li.menu-item-has-children").removeClass("open");
        parentLi.addClass("open");
      }
    });
  }
});

jQuery(document).ready(function ($) {
  $(".fotowoltaika_wyrozniki__accordion .card .open").on("click", function (e) {
    if ($(this).hasClass("close")) {
      $(".fotowoltaika_wyrozniki__accordion .card").each(function () {
        $(this).removeClass("active");
      });
      $(this).removeClass("close");
    } else {
      $(".fotowoltaika_wyrozniki__accordion .card").each(function () {
        $(this).removeClass("active");
      });
      $(this).parent(".card").addClass("active");
      $(this).addClass("close");
    }
  });

  $(".columbus_intelligence_funkcje span.toggle-more").on(
    "click",
    function (e) {
      if ($(this).hasClass("open")) {
        $(".columbus_intelligence_funkcje ul").slideUp();
        $(this).removeClass("open");
      } else {
        $(".columbus_intelligence_funkcje ul").slideDown();
        $(this).addClass("open");
      }
    }
  );

  if ($("#menu-item-106486").length > 0) {
    $("#menu-item-106486 a").attr("id", "contact-button");
    $("#menu-item-106486 a").attr("class", "menu-button");
  }

  if ($(window).width() > 960) {
    $(".columbus_hero_termo .dot").hover(function () {
      var dotClass = $(this)
        .attr("class")
        .split(" ")
        .find(function (className) {
          return className.startsWith("dot_");
        });
      $(".legend").hide();
      $(".legend_" + dotClass).show();
    });
  } else {
    $(".columbus_hero_termo .dot").click(function () {
      var dotClass = $(this)
        .attr("class")
        .split(" ")
        .find(function (className) {
          return className.startsWith("dot_");
        });
      $(".legend").hide();
      $(".legend_" + dotClass).show();
      $(".image_mobile").animate({ top: "5px" });
    });
  }

  if ($(".grant_tabs").length) {
    $(".grant_tabs a:first-child").addClass("active");
  }
  function setActiveTab(targetId) {
    $(".grant_tabs a").removeClass("active");
    $(".grant_tab").removeClass("active");
    $('.grant_tabs a[href="' + targetId + '"]').addClass("active");
    $(targetId).addClass("active");
  }

  var currentHash = window.location.hash;
  if (currentHash == '#faq') {
    setTimeout(function(){
      $("html, body").animate(
        {
          scrollTop: $(currentHash).offset().top,
        },
        500
      );
    }, 1000);
  }
  else if (currentHash) {
    setActiveTab(currentHash);
    $("html, body").animate(
      {
        scrollTop: $(currentHash).offset().top,
      },
      500
    );
  }

  $(".grant_tabs a").on("click", function (e) {
    e.preventDefault();
    var targetId = $(this).attr("href");
    setActiveTab(targetId);

    if ($(window).width() >= 960) {
      $(".grant_tab").hide();
      $(targetId).show();
    } else {
      $("html, body").animate(
        {
          scrollTop: $(targetId).offset().top,
        },
        500
      );
    }
  });

  function checkResolution() {
    if ($(window).width() < 960) {
      $(".grant_tab").css("display", "block");
      $(".grant_tabs").css("position", "relative");
      if (window.location.hash) {
        var currentHash = window.location.hash;
        setActiveTab(currentHash); 
        $("html, body").animate(
          {
            scrollTop: $(currentHash).offset().top,
          },
          500
        );
      }
    } else {
      $(".grant_tab:not(.active)").css("display", "none");
    }
  }

  checkResolution();
  $(window).resize(function () {
    checkResolution();
  });
});
